import { render, staticRenderFns } from "./DetailDirectionInfo.vue?vue&type=template&id=876e16d0&scoped=true&"
import script from "./DetailDirectionInfo.vue?vue&type=script&lang=js&"
export * from "./DetailDirectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876e16d0",
  null
  
)

export default component.exports